<template>
  <section class="edit-map">
    <div class="edit-map__content">
      <div
        v-for="(item, index) in v"
        :key="index"
        class="edit-map__item"
      >
        <v-row class="edit-map__row">
          <v-col sm="4" class="edit-map__row-item">
            <v-text-field
              type="text"
              dense
              outlined
              hide-details="auto"
              v-model="item.key"
              @input="updateV"
              class="edit-map__input"
            />
          </v-col>
          <v-col sm="7" class="edit-map__row-item">
            <v-text-field
              type="text"
              dense
              outlined
              hide-details="auto"
              v-model="item.value"
              @input="updateV"
              class="edit-map__input"
            />
          </v-col>
          <div class="d-flex align-center">
            <v-btn
              icon
              color="error"
              @click="deleteRow(item.key)"
            >
              <apio-icon size="24" name="ui-trash"></apio-icon>
            </v-btn>
          </div>
        </v-row>
      </div>
    </div>

    <apio-button
      class="mt-4"
      type="primary"
      @click="addRow()"
    >
      Add new row
    </apio-button>
  </section>
</template>

<script>
export default {
  name: "EditMap",
  data: () => ({
    key: 0,
  }),
  props: {
    value: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  computed: {
    v: {
      set(val) {
        let obj = {}
        for (let key in val) {
          obj[val[key].key] = val[key].value
        }
        this.$emit("input", obj);
        this.$emit('setAsObject', obj);
      },
      get() {
        let rr = []
        for (let key in this.value) {
            rr.push({key: key, value: this.value[key] })
        }
        return rr
      }
    }
  },
  methods: {
    deleteRow(key) {
      const currentData = this.v.filter(item => item.key !== key)
      this.v = currentData
    },
    addRow() {
      this.v = [
        ...this.v,
        {
          value: `value-${this.key}`,
          key: `key-${this.key}`,
        },
      ]
    },
    updateV() {
      let obj = {}
      for (let key in this.v) {
        obj[this.v[key].key] = this.v[key].value
      }
      this.$emit("input", obj);
      this.$emit('setAsObject', obj);
    },
  },
};
</script>

